import React from 'react'
import './contact.css'

const Contact = () => {
  return (
    <main role="main" id="contact-section" className="contact">
      <h1>CONTACT</h1>
      <div className="contact-content">
        <p>email: huntertread@gmail.com</p>
      </div>
      <p alt="a custom font is used which transforms alpha-numeric characters in to pixel monsters" className="character-container">J</p>
    </main>
  )
}

export default Contact